import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import './styles.scss';

const ButtonPrimary = ({ classNames = [], ...props }) => (
    <Button {...props} classNames={['custom-btn-primary', ...classNames]} />
);

ButtonPrimary.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};

export default ButtonPrimary;
